export default "<!--<app-search></app-search>-->\n"